import Requester from '../../helpers/requester';
import { HTTP_METHODS } from '../../helpers/constants';
import { API_PATHS } from '../../helpers/endpoints';
import { getTaskTemplatesList } from 'store/requests/taskPlans';

export default {
  getTaskPlanList: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.TASK_PLAN_LIST}/search?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteTaskPlanList: async (id) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.DELETE,
        url: `${API_PATHS.TASK_PLAN_LIST}/${id}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  addTaskPlanList: async (payload, type) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.TASK_PLAN_LIST}${type ? `/${type}` : ''}`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getStoreType: async (queryString) => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.STORE_TYPES}/search?${queryString}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  editTaskPlanList: async (payload, id) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PUT,
        url: `${API_PATHS.TASK_PLAN_LIST}/${id}`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getTaskGroupList: async (params) => {
    try {
      const queryString = new URLSearchParams(params).toString(); 
      const response = await Requester.submit({
        url: `${API_PATHS.TASK_GROUP_LIST}?${queryString}`, 
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  editTaskGroupList: async (payload, id) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PUT,
        url: `${API_PATHS.TASK_GROUP_LIST}/${id}`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  addTaskGroupList: async (payload) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.TASK_GROUP_LIST}`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  deleteTaskGroupList: async (id, payload) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.DELETE,
        url: `${API_PATHS.TASK_GROUP_LIST}/${id}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getRoleType: async () => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.ROLE_TYPES}/search?page=0&size=200`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getTaskTemplatesList: async (params) => {
    try {
      const queryString = new URLSearchParams(params).toString(); 
      const response = await Requester.submit({
        url: `${API_PATHS.TASK_TEMPLATES_LIST}?${queryString}`, 
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  addTaskTemplatesList: async (payload) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.POST,
        url: `${API_PATHS.TASK_TEMPLATES_LIST}`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  getTaskPeriodsList: async () => {
    try {
      const response = await Requester.submit({
        url: `${API_PATHS.PERIODS_LIST}/search`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  editTaskTemplatesList: async (payload, id) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.PUT,
        url: `${API_PATHS.TASK_TEMPLATES_LIST}/${id}`,
        data: payload,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteTaskTemplatesList: async (id, payload) => {
    try {
      const response = await Requester.submit({
        method: HTTP_METHODS.DELETE,
        url: `${API_PATHS.TASK_TEMPLATES_LIST}/${id}`,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },
};
